import "./message-custom.css";
import "@/styles";
import { iconCloseCircle } from "@/services/assets";
import { useEffect } from "react";

export const ErrorMessage = ({
  title = "Thành công",
  content,
  onClose = () => {},
  onClick = () => {},
  duration = 10000,
}: {
  title?: string | null;
  content: string;
  onClose?: () => void;
  onClick?: () => void;
  duration?: number;
}) => {
  useEffect(() => {
    setTimeout(() => {
      onClose();
    }, duration);
  }, []);

  return (
    <div className="wrap-custom-message">
      <div
        onClick={() => {
          onClick();
        }}
        className="custom-message"
        style={{ position: "relative", backgroundColor: "#FDF2F2" }}
      >
        <div
          className="custom-message__tag"
          style={{ backgroundColor: "#F05252" }}
        ></div>

        <img
          alt=""
          src={iconCloseCircle}
          style={{ height: "32px", width: "32px" }}
        />

        <div
          className="column"
          style={{
            width: "100%",
            gap: "8px",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span
            className="fontSize--16 lineHeight--24 fontWeight--700"
            style={{
              color: "#F05252",
              width: "100%",
            }}
          >
            {title}
          </span>
          <span
            className="fontSize--14 lineHeight--20 fontWeight--400"
            style={{
              color: "#374151",
              width: "100%",
              whiteSpace: "initial",
              wordBreak: "break-word",
              wordWrap: "break-word",
            }}
          >
            {content}
          </span>
        </div>
      </div>
    </div>
  );
};
